import clsx from "clsx"
import styles from "./HowToWork.module.scss"
import { Block } from "./Block"

export function Section({ id, number, title, body = [], rulesUrl }) {
    return (
        <section id={id} className={styles.section}>
            <header className={styles.sectionHead}>
                <span className={styles.number} aria-hidden="true">
                    {number}
                </span>
                <h2 className={styles.sectionTitle}>{renderTitle(title, rulesUrl)}</h2>
            </header>
            {body.length > 0 && (
                <div className={styles.sectionBody}>
                    {body.map((block, i) => (
                        <Block key={i} {...block} rulesUrl={rulesUrl} />
                    ))}
                </div>
            )}
        </section>
    )
}

function renderTitle(title, rulesUrl) {
    if (typeof title === "string") return title

    if (title.node) return title.node

    if (title.link) {
        const href = title.link.dynamicRules ? rulesUrl : title.link.href
        return (
            <>
                {title.before}{" "}
                <a className={clsx(styles.linkBorder, styles.textSemibold)} href={href}>
                    {title.link.label}
                </a>
                {title.after ? (/^[.,;:!?]/.test(title.after) ? title.after : <> {title.after}</>) : null}
            </>
        )
    }

    return null
}
